export const issueTypes = [
  {
    id: '1',
    name: 'AnimalSafetyConcerns',
    label: 'Animal safety concerns',
    checked: false,
  },
  {
    id: '2',
    name: 'BreachOfCondition',
    label: 'Breach of condition',
    checked: false,
  },
  {
    id: '3',
    name: 'ExceededTime',
    label: 'Exceeded time limit',
    checked: false,
  },
  {
    id: '4',
    name: 'IndecentOrOffensiveBehaviour',
    label: 'Indecent or offensive behaviour',
    checked: false,
  },
  {
    id: '5',
    name: 'Noise',
    label: 'Excessive noise',
    checked: false,
  },
  {
    id: '6',
    name: 'Obstruction',
    label: 'Obstructing road or pavement',
    checked: false,
  },
  {
    id: '7',
    name: 'ProhibitedItems',
    label: 'Prohibited items e.g. amplifiers',
    checked: false,
  },
  {
    id: '8',
    name: 'UnlicensedStreetTrading',
    label: 'Unlicensed street trading, e.g. selling CDs',
    checked: false,
  },
];
